/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { UpdateFrequency } from '../types/utils';
import { User } from './user-model';

export class UpdateCompanyInput {
	representativeFirstName?: string

	representativeLastName?: string
}

export const CompanyUpdatability = {
	representativeFirstName: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
	representativeLastName: { frequency: UpdateFrequency.ConditionallyUpdatable, condition: (user: User) => !user.isVerificationStarted() },
}